import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { TOPBAR_HEIGHT } from 'app/layout/dashboard/Dashboard.utils';

// import { UseStylesProps } from './Clips.types';
// import { SIDEBAR_WIDTH, SIDEBAR_WIDTH_EXPANDED, TOPBAR_HEIGHT } from './Dashboard.utils';

export const useStyles = makeStyles<Theme>(
  ({ spacing, palette: { white, green, black }, typography: { fontWeightBold }, breakpoints }) => ({
    content: {
      display: 'flex',
      // backgroundColor: white.main,
      justifyContent: 'center',
      fontFamily: 'Open Sans',
      fontSize: spacing(6),
      fontWeight: fontWeightBold,
      marginBottom: spacing(5),
    },
    container: {
      backgroundColor: white.dark,
    },
    emailTitle: {
      fontWeight: `${fontWeightBold} !important`,
      fontSize: `${spacing(3.5)} !important`,
      justifyContent: 'center',
      display: 'flex',
      fontFamily: `Open Sans !important`,
      marginBottom: `${spacing(1.5)} !important`,
      lineHeight: spacing(5),
    },
    card: {
      margin: 'auto',
      width: spacing(48.5),
      // height: spacing(36),
      backgroundColor: white.light,
      borderRadius: spacing(1.25),
      padding: spacing(2),
      // justifyContent: 'space-between',
    },
    emailInput: {
      padding: spacing(1),
      marginBottom: `${spacing(2)} !important`,
    },
    button: {
      width: '100%',
      backgroundColor: `${green.main} !important`,
      color: `${white.main} !important`,
      marginTop: `${spacing(4)} !important`,
    },
    clientText: {
      // margin: spacing(3, 15.75, 3, 15.75),
      fontSize: `${spacing(4)} !important`,
      fontStyle: `Open Sans !important`,
      textAlign: 'center',
      fontWeight: `${fontWeightBold}  !important`,
      color: '#595959',
      marginTop: `${spacing(5)} !important`,
    },
    imageContainer: {
      display: 'flex',
      padding: spacing(4),
      justifyContent: 'center',
      HeaderImage: {
        padding: spacing(4),
      },
      margin: spacing(1, 4, 8, 4),
      // position: 'relative',
    },
    images: {
      margin: spacing(0, 6, 0, 6),
    },
    root: {
      height: `calc(100vh - ${TOPBAR_HEIGHT}px)`,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
    cardContainer: {
      [breakpoints.up('md')]: {
        marginTop: spacing(8),
      },
    },
    link: {
      display: 'flex',
      justifyContent: 'center',
      color: `${black.dark} !important`,
      fontWeight: `${fontWeightBold} !important`,
      marginTop: `${spacing(1)} !important`,
      fontFamily: `Open Sans !important`,
    },
    stageClipLogo: {
      height: '10%',
      [breakpoints.up('md')]: {
        display: 'none',
      },
      margin: spacing(1, 0, 1, 2.5),
      display: 'flex',
      justifyContent: 'center',
      marginBottom: `${spacing(1)} !important`,
    },
    institutionContainer: {
      [breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    emailDescription: {
      fontSize: spacing(2),
      justifyContent: 'center',
      display: 'flex',
      fontFamily: `Open Sans !important`,
      textAlign: 'center',
      marginBottom: `${spacing(1)} !important`,
      fontWeight: `${fontWeightBold} !important`,
    },
    icon: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: spacing(1),
    },
    fullName: {
      fontSize: spacing(2),
      justifyContent: 'center',
      display: 'flex',
      fontFamily: `Open Sans !important`,
      textAlign: 'center',
      marginBottom: `${spacing(1.5)} !important`,
      fontWeight: `${fontWeightBold} !important`,
    },
    selectInstitution: {
      marginBottom: `${spacing(1.5)} !important`,
    },
  }),
);
